import React from "react";

const LayoutContent = ({ children }) => {
    const themes = window.themes || {};
    const useBgImage = Boolean(themes.use_background_image);
    const BgImage = themes.background_image_theme
        ? themes.background_image_theme
        : "";
    const bgColor = themes.background_color_theme
        ? themes.background_color_theme
        : "#000";
    const bgOpacity = themes.overlay_opacity ?? 0;
    const bgImageStyle = {
        background: `linear-gradient(rgba(0, 0, 0, ${bgOpacity}), rgba(0, 0, 0, ${bgOpacity})), no-repeat
      url(${BgImage})`,
        backgroundSize: "cover",
    };
    const bgColorStyle = {
        // background: `linear-gradient(rgba(0, 0, 0, ${bgOpacity}), rgba(0, 0, 0, ${bgOpacity}))`,
        // backgroundColor: bgColor
        background:
            "linear-gradient(63deg, var(--ASML-Light-Blue, #00A3E0) 0%, var(--ASML-Blue, #10069F) 100%)",
    };
    const style = useBgImage ? bgImageStyle : bgColorStyle;

    return (
        <div className="layout-content" style={style}>
            {children}
        </div>
    );
};

export default LayoutContent;
